import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import { IoIosWarning as WarningIcon } from 'react-icons/io'
import {
  deleteFromLocalStorage,
  getAppConfig,
  getLocalStorage,
  setLocalStorage,
} from 'config/appConfig'
import {
  getMonthStringList,
  getMonthNumber,
  getLocaleCodeFromUrl,
  i18nTranslate,
} from 'src/utils'
import { customerContainer, subscriptionContainer } from 'src/models'
import { SubscriptionInfiniteScrollV2 } from 'src/views/components/SubscriptionInfiniteScrollV2'
import { SubscriptionFooter } from '../SubscriptionFooter'
import { overlayState } from 'src/views/components'
import { SubscriptionNextOrderView } from './SubscriptionNextOrderView'
import { SubscriptionErrorNotification } from './SubscriptionErrorNotification'
import {
  getUpcomingTapTitle,
  isPastDateV2,
  isToShowTwoMonthCalender,
} from 'src/deps'
import './styles.scss'
@observer
class SubscriptionNextOrders extends React.Component {
  activeTabRef = React.createRef()
  @observable showFreeGiftsModal = false
  @observable availableOrderDates = []
  nextProcessDate = ''
  pastOrder = false
  isToEnableOneTimeFrequency =
    getAppConfig()?.oneTimeFrequencyEnabled === 'true'

  async componentDidMount() {
    const isToShowTwoMonth = isToShowTwoMonthCalender() || false
    if (
      this.props.activeTab === 'nextOrder' &&
      this.props.availableOrderDates.length > 0
    ) {
      const firstDate = this.props.availableOrderDates[0]
      const selectedMonth = firstDate.getMonth()
      const defaultDate = firstDate.getDate()
      const monthText = getMonthStringList()[selectedMonth]
      const tapTittle = `${monthText} ${defaultDate}`
      const existingDate = subscriptionContainer.subscriptionSelectedDate
      const isExistingValid =
        existingDate &&
        this.props.availableOrderDates.some(date => {
          const m = getMonthStringList()[date.getMonth()]
          return `${m} ${date.getDate()}` === existingDate
        })
      if (isExistingValid) {
        setLocalStorage('subscriptionNextOrderSelectedDate', existingDate)
      } else {
        subscriptionContainer.subscriptionSelectedDate = tapTittle
        setLocalStorage('subscriptionNextOrderSelectedDate', tapTittle)
      }

      deleteFromLocalStorage('scheduleOrderSelectedDate')
      const selectedDate =
        getLocalStorage('subscriptionNextOrderSelectedDate') || ''
      if (selectedDate) {
        const locale =
          getLocaleCodeFromUrl({
            locationProps: this.props,
          })?.replace('_', '-') || 'en-US'
        let month = selectedDate.split(' ')[0]
        if (
          locale.toLowerCase() === 'vi-us' ||
          locale.toLowerCase() === 'vi-ca'
        ) {
          month = `${selectedDate.split(' ')[0]} ${selectedDate.split(' ')[1]}`
        }
        const subscriptionMonth = getMonthNumber(locale, month)
        const date = selectedDate ? selectedDate.split(' ')?.[1] : ''
        if (
          this.props.availableOrderDates.length &&
          !this.props.availableOrderDates.some(
            item =>
              item.getDate() === parseInt(date) &&
              item.getMonth() + 1 === subscriptionMonth
          )
        ) {
          deleteFromLocalStorage('subscriptionNextOrderSelectedDate')
          const selectedMonth = this.props.availableOrderDates[0]?.getMonth()
          const defaultDate = this.props.availableOrderDates[0]?.getDate()
          const monthText = getMonthStringList()[selectedMonth]
          const tapTittle = `${monthText} ${defaultDate}`
          subscriptionContainer.subscriptionSelectedDate = tapTittle
          if (isToShowTwoMonth) {
            const scheduleDate = selectedDate
            setLocalStorage('scheduleOrderSelectedDate', scheduleDate)
            // await this.props.handleTabChange('schedule')
          }
        } else {
          subscriptionContainer.subscriptionSelectedDate = selectedDate
        }
      }
      this.invokeAPIsOnload()
    } else {
      this.invokeAPIsOnload(true)
    }
    this.scrollToSelectedDate()
  }
  async componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== this.props.activeTab) {
      if (this.props.activeTab === 'nextOrder') {
        this.invokeAPIsOnload()
      } else {
        this.invokeAPIsOnload(true)
      }
    } else if (
      this.props.activeTab === 'nextOrder' &&
      getLocalStorage('subscriptionNextOrderSelectedDate') !==
        subscriptionContainer.subscriptionSelectedDate
    ) {
      setLocalStorage(
        'subscriptionNextOrderSelectedDate',
        subscriptionContainer.subscriptionSelectedDate
      )
    } else if (
      this.props.activeTab === 'nextOrder' &&
      this.props.isToRenderDataInNextOrderTab &&
      prevProps.getAllSubscriptionLastCallTime !==
        this.props.getAllSubscriptionLastCallTime
    ) {
      const isToShowTwoMonth = isToShowTwoMonthCalender() || false
      const selectedDate =
        getLocalStorage('subscriptionNextOrderSelectedDate') || ''
      if (selectedDate) {
        const locale =
          getLocaleCodeFromUrl({
            locationProps: this.props,
          })?.replace('_', '-') || 'en-US'
        let month = selectedDate.split(' ')[0]
        if (
          locale.toLowerCase() === 'vi-us' ||
          locale.toLowerCase() === 'vi-ca'
        ) {
          month = `${selectedDate.split(' ')[0]} ${selectedDate.split(' ')[1]}`
        }
        const subscriptionMonth = getMonthNumber(locale, month)
        const date = selectedDate ? selectedDate.split(' ')?.[1] : ''
        if (
          this.props.availableOrderDates.length &&
          !this.props.availableOrderDates.some(
            item =>
              item.getDate() === parseInt(date) &&
              item.getMonth() + 1 === subscriptionMonth
          )
        ) {
          deleteFromLocalStorage('subscriptionNextOrderSelectedDate')
          const selectedMonth = this.props.availableOrderDates[0]?.getMonth()
          const defaultDate = this.props.availableOrderDates[0]?.getDate()
          const monthText = getMonthStringList()[selectedMonth]
          const tapTittle = `${monthText} ${defaultDate}`
          subscriptionContainer.subscriptionSelectedDate = tapTittle
          if (isToShowTwoMonth) {
            const scheduleDate = selectedDate
            setLocalStorage('scheduleOrderSelectedDate', scheduleDate)
            // await this.props.handleTabChange('schedule')
          }
        } else {
          subscriptionContainer.subscriptionSelectedDate = selectedDate
        }
      }
      this.invokeAPIsOnload()
    }
    this.scrollToSelectedDate()
    if (this.props.activeTab === 'nextOrder' && this.activeTabRef.current) {
      this.activeTabRef.current.focus()
    }
  }

  scrollToSelectedDate = () => {
    const scrollBehavior = { behavior: 'smooth', block: 'center' }
    const element = document.querySelector(
      '[class="nav-item nav-link active"] div.tab-header-section'
    )

    if (element) {
      element.scrollIntoView(scrollBehavior)
    }
  }

  invokeAPIsOnload = async showAll => {
    overlayState.toggleLoader()
    if (showAll) {
      const subscriptionMonth = showAll ? '' : new Date().getMonth() + 1
      const response =
        await subscriptionContainer.getAllSubscriptionsPreference(
          customerContainer.userId,
          subscriptionMonth,
          showAll
        )
    } else {
      if (this.props.availableOrderDates.length > 0) {
        const selectedMonth = this.props.availableOrderDates[0]?.getMonth()
        const defaultDate = this.props.availableOrderDates[0]?.getDate()
        const monthText = getMonthStringList()[selectedMonth]
        const tapTittle = `${monthText} ${defaultDate}`
        if (subscriptionContainer.subscriptionSelectedDate) {
          this.getSelectedMonthData(
            subscriptionContainer.subscriptionSelectedDate
          )
        } else {
          this.getSelectedMonthData(tapTittle)
        }
      }
    }

    await this.props.getUpComingOrders()
    overlayState.toggleLoader()
  }
  getSelectedMonthData = async tapTittle => {
    overlayState.toggleLoader()
    subscriptionContainer.subscriptionPromoApplied = false
    const locale =
      getLocaleCodeFromUrl({
        locationProps: this.props,
      })?.replace('_', '-') || 'en-US'
    let month = tapTittle.split(' ')[0]
    if (locale.toLowerCase() === 'vi-us' || locale.toLowerCase() === 'vi-ca') {
      month = `${tapTittle.split(' ')[0]} ${tapTittle.split(' ')[1]}`
    }
    const subscriptionMonth = getMonthNumber(locale, month)
    const date =
      tapTittle && locale.toLowerCase() === 'vi-us'
        ? tapTittle.split(' ')?.[2]
        : tapTittle.split(' ')?.[1] || ''
    const response = await subscriptionContainer.getAllSubscriptionsPreference(
      customerContainer.userId,
      subscriptionMonth,
      false,
      '',
      date
    )
    subscriptionContainer.subscriptionPromoMonth = subscriptionMonth
    subscriptionContainer.subscriptionPromoDate = date
    overlayState.toggleLoader()
    subscriptionContainer.subscriptionSelectedDate = tapTittle
  }

  renderTabHeader = (displayDate, isActive) => {
    return (
      <div
        className="tab-header-section"
        role="button"
        tabIndex={isActive ? 0 : -1}
        data-testid="qa-subscription-date"
        ref={isActive ? this.activeTabRef : null}
        aria-label={displayDate}>
        <span className="date" data-testid="qa-subscription-date" tabIndex={0}>
          {displayDate}
        </span>
        {this.pastOrder && (
          <div className="warning-icon">
            <WarningIcon aria-label={'warning icon'} />
          </div>
        )}
        <span className="divider">|</span>
      </div>
    )
  }

  setNextProcessDate = (displayYear, selectedMonth, defaultDate) => {
    const processDate =
      displayYear && selectedMonth >= 0 && defaultDate
        ? new Date(displayYear, selectedMonth, defaultDate)
        : new Date()
    const option = {
      // timeZone: 'UTC',
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }
    this.nextProcessDate = processDate.toLocaleDateString('default', option)
  }
  // getIcon = () => {
  //   return <warningIcon aria-label={'warning'} />
  // }
  ordinalDate = date => {
    let errorDate = date
    return (
      date +
      (date % 10 == 1 && date != 11
        ? 'st'
        : date % 10 == 2 && date != 12
          ? 'nd'
          : date % 10 == 3 && date != 13
            ? 'rd'
            : 'th')
    )
  }
  isProcessNowErrorForOTP = () => {
    let areAllOtpInPrimarySubscription = true
    let toDisableSubmitOrder = false
    let isActiveLegacySubsExists = false
    let activeCount = 0
    const response =
      Array.isArray(subscriptionContainer.flexibleSubscriptionResponse) &&
      subscriptionContainer.flexibleSubscriptionResponse?.length
        ? subscriptionContainer?.flexibleSubscriptionResponse?.[0]
            ?.subscriptions
        : []
    const subscriptionValidLength = response.length > 0 ? true : false
    subscriptionValidLength &&
      response?.forEach(obj => {
        let skus = (obj?.itemInfo?.length && obj?.itemInfo?.[0]?.skus) || []
        let stockInventory = (
          obj?.itemInfo?.[0]?.skus?.[0]?.inventory || ''
        ).toLowerCase()
        let stockStatus = (
          obj?.itemInfo?.[0]?.skus?.[0]?.status || ''
        ).toLowerCase()

        if (skus.length > 1) {
          const bundleObj = skus.find(
            obj => obj.type === 'BUNDLE' || obj.type === 'SKUKIT'
          )

          stockInventory = bundleObj?.inventory?.toLowerCase()
          stockStatus = bundleObj?.status?.toLowerCase()
        }

        /* Condition is checked here for any subscription items or not skipped items or eligible subscription items are there
         * to not display the one-time error on top process now error msg and process now modal error msg
         * this Condition includes product availablity check also because when there is no instock product means,
         * that time also one-time item will not get processed */
        let isSubsItemsAreInstockAndActive =
          stockInventory !== 'out of stock' && stockStatus !== 'inactive' //To check whether subscribed items are instock and active
        if (
          isSubsItemsAreInstockAndActive &&
          obj?.properties?.isSkipped !== 'true'
        ) {
          activeCount = activeCount + 1
        }
        if (
          obj?.type !== 'VARIABLE_SINGLE_ORDER' &&
          obj?.properties?.isSkipped !== 'true' &&
          isSubsItemsAreInstockAndActive &&
          !obj.enableItemLevelProcessing
        ) {
          areAllOtpInPrimarySubscription = false
        }
        // This is to check legacy subscription items to enable/disable submit order button in process now modal
        if (obj.enableItemLevelProcessing && isSubsItemsAreInstockAndActive) {
          isActiveLegacySubsExists = true
        }
        toDisableSubmitOrder = isActiveLegacySubsExists
          ? false
          : areAllOtpInPrimarySubscription
            ? true
            : false
      })
    /*
     * Adding Condition based on whole array types to avoid error on Unskip
     */
    const objectTypesOnlySingleOrder = subscriptionValidLength
      ? subscriptionContainer?.selectedSubscription?.map(item => {
          return item?.type
        })
      : []
    const objectTypeSkipped = subscriptionValidLength
      ? subscriptionContainer?.selectedSubscription?.map(item => {
          return item?.properties?.isSkipped
        })
      : []
    if (
      !objectTypesOnlySingleOrder?.includes('VARIABLE_SINGLE_ORDER') &&
      !objectTypeSkipped.includes(false)
    ) {
      areAllOtpInPrimarySubscription = false
    } else if (!objectTypesOnlySingleOrder?.includes('VARIABLE_MULTI_ORDER')) {
      areAllOtpInPrimarySubscription = true
    }

    let toShowOTPError =
      (areAllOtpInPrimarySubscription &&
        subscriptionContainer?.selectedSubscription?.length > 0) ||
      false
    const processNowFlagsForOneTime = {
      toShowOTPError: toShowOTPError,
      toDisableSubmitOrder: toDisableSubmitOrder,
      activeCount: activeCount,
    }
    return processNowFlagsForOneTime
  }

  renderNextOrderView = (date, key) => {
    this.pastOrder = false
    const selectedMonth = date.getMonth()
    const defaultDate = date.getDate()
    const displayYear = date.getFullYear()
    const monthText = getMonthStringList()[selectedMonth]
    const tapTittle = `${monthText} ${defaultDate}`
    const displayDate = `${monthText} ${defaultDate}, ${displayYear}`
    this.setNextProcessDate(displayYear, selectedMonth, defaultDate)
    this.pastOrder = isPastDateV2(date)
    const errorDate = `${monthText} ${this.ordinalDate(defaultDate)}`
    let processNowFlagsForOneTime = this.isProcessNowErrorForOTP() || {}
    const upcomingTapTitle = getUpcomingTapTitle(this.props.availableOrderDates)
    const isUpcomingDate = tapTittle === upcomingTapTitle
    const isActive =
      tapTittle ===
      (subscriptionContainer.subscriptionSelectedDate || tapTittle)
    return (
      <Tab
        eventKey={tapTittle}
        title={this.renderTabHeader(displayDate, isActive)}
        className="p-0"
        tabClassName={isActive ? 'active' : ''}
        key={tapTittle}>
        {this.pastOrder && (
          <div className="past-order-warning">
            <SubscriptionErrorNotification
              case="ProcessError"
              date={errorDate}
            />
          </div>
        )}
        {processNowFlagsForOneTime?.toShowOTPError && (
          <div className="one-time-warning mt-2">
            {this.isToEnableOneTimeFrequency && (
              <SubscriptionErrorNotification case="OneTimeError" />
            )}
          </div>
        )}
        <SubscriptionNextOrderView
          {...this.props}
          nextProcessDate={this.nextProcessDate}
          ProcessDate={defaultDate}
          selectedMonth={selectedMonth}
          isUpcomingDate={isUpcomingDate}
          processNowFlagsForOneTime={processNowFlagsForOneTime}
          toShowOTPError={processNowFlagsForOneTime?.toShowOTPError || false}
          activeCount={processNowFlagsForOneTime?.activeCount}
        />
      </Tab>
    )
  }
  handleSelect = name => {
    subscriptionContainer.subscriptionSelectedDate = name
    this.getSelectedMonthData(name)
    setLocalStorage('subscriptionNextOrderSelectedDate', name)
    this.scrollToSelectedDate()
  }
  renderTabContainer = () => {
    const { availableOrderDates } = this.props
    let isSelectDate = ''
    let isSelectMonth = ''
    if (subscriptionContainer.subscriptionSelectedDate) {
      isSelectMonth =
        subscriptionContainer.subscriptionSelectedDate.split(' ')[0]
      isSelectDate =
        subscriptionContainer.subscriptionSelectedDate.split(' ')[1]
      isSelectDate = parseInt(isSelectDate)
    }
    const selectedMonth = availableOrderDates[0]?.getMonth()
    const defaultDate = availableOrderDates[0]?.getDate()
    const monthText = getMonthStringList()[selectedMonth]
    const tapTittle = subscriptionContainer.subscriptionSelectedDate
      ? subscriptionContainer.subscriptionSelectedDate
      : `${monthText} ${defaultDate}`

    return (
      <div
        className="subscription-next-order-wrapper"
        data-testid="qa-subscription-next-order-wrapper"
        role="tablist">
        <Tabs
          defaultActiveKey={tapTittle}
          activeKey={tapTittle}
          id="uncontrolled-tab-example"
          onSelect={e => this.handleSelect(e)}
          className="subscription-next-tabs-section"
          unmountOnExit={true}
          fill>
          {availableOrderDates?.map((date, key) => {
            return this.renderNextOrderView(date, key)
          })}
        </Tabs>
      </div>
    )
  }
  render() {
    return (
      <>
        {this.props.availableOrderDates.length > 0 ? (
          <div className="mt-4">
            {this.renderTabContainer()}
            <SubscriptionFooter {...this.props} isFromNextOrder={true} />
          </div>
        ) : (
          <div className="subscription-next-order-search-section mt-4">
            <SubscriptionInfiniteScrollV2
              addButtonType="plus"
              {...this.props}
            />
            <h4 className="mt-5">
              {i18nTranslate(
                'subscription.noOrdersFoundLine1',
                'Nothing happening here in the next 30 days!'
              )}
            </h4>
            <h4 className="mt-3">
              {i18nTranslate(
                'subscription.noOrdersFoundLine2',
                'Orders scheduled to ship within the next 30 days appear here for management.'
              )}
            </h4>
          </div>
        )}
      </>
    )
  }
}

export { SubscriptionNextOrders }
export default SubscriptionNextOrders
